<template>
    <div>
        <TopHeader/>
        <div class="bg desc">
            <div class="desc-content wrapper">
                <div class="img">
                    <img src="../assets/logo2.png" alt="">
                </div>
                <p>360攻击欺骗防御系统，作为内网安全感知的最后一道防线，利用欺骗伪装技术，制定符合当前业务场景的欺骗方案，在攻击路径上投放诱饵、部署虚假服务，混淆攻击目标，实时、精确感知内网威胁并对攻击者展开溯源追踪，使企业真实资产得到保护，也为安全人员调整针对性的安全策略预留足够的时间。</p>
            </div>
        </div>
    </div>
</template>
<script>
import TopHeader from "./header"
export default {
    components: {
        TopHeader
    }
}
</script>
<style>
.desc{
    color: #000;
    height: 240px;
    font-size: 14px;
}

.desc-content {
    height: 240px;
    display: flex;
    align-items: center;
}
.desc img{
    /* width: 200px; */
    height: 150px;
    margin: 50px 20px;
}
.desc .img{
    text-align: center;
}
.desc-content p{
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 30px;
    padding: 30px 20px 70px;
}
</style>